import "./TodosError.css";

function TodosError() {
  return <p className='Todos-error'>Whoops!! Ocurrio un error</p>;
}

export { TodosError };
